import React, { useState } from 'react';
import { Button, Spinner, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { MessageSquare, HelpCircle, ExternalLink } from 'react-feather';
import classnames from 'classnames';

const NEW_APP_LOGIN_URL = 'https://app.iuli.com.br/login';

const Footer = (props) => {
  const [isIframeLoading] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const footerTypeArr = ['sticky', 'static', 'hidden'];

  const handleClickChatBot = () => {
    setShowSupportModal(true);
  };

  const handleGoToNewApp = () => {
    window.open(NEW_APP_LOGIN_URL, '_blank', 'noopener,noreferrer');
    setShowSupportModal(false);
  };
  return (
    <footer
      className={classnames('footer footer-light', {
        'footer-static':
          props.footerType === 'static' ||
          !footerTypeArr.includes(props.footerType),
        'd-none': props.footerType === 'hidden',
      })}
    >
      <p className="mb-0 clearfix">
        <span className="float-md-left d-block d-md-inline-block mt-25">
          COPYRIGHT © {new Date().getFullYear()}
          <a
            href="https://iuli.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            IULI
          </a>
          Todos direitos reservados
        </span>
      </p>
      <Button
        disabled={isIframeLoading}
        color="warning"
        className="btn-icon btn-chat-bot rounded-circle scroll-top"
        onClick={handleClickChatBot}
      >
        {isIframeLoading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            color="white"
          />
        ) : (
          <MessageSquare size={15} />
        )}
      </Button>

      <Modal
        isOpen={showSupportModal}
        toggle={() => setShowSupportModal(false)}
        centered
        size="md"
      >
        <ModalHeader toggle={() => setShowSupportModal(false)}>
          <h4 className="modal-title mb-0 d-flex align-items-center">
            <HelpCircle size={20} className="mr-1" />
            Como podemos ajudar?
          </h4>
        </ModalHeader>
        <ModalBody>
          <div className="text-center px-2 py-3">
            <h5 className="mb-2">Suporte agora é na nova plataforma Iuli</h5>
            <p className="text-muted mb-3">
              Lançamos uma versão nova e mais moderna do Iuli, com o suporte
              integrado direto no menu de ajuda — chat ao vivo, abertura de
              chamados e base de conhecimento, tudo em um só lugar.
            </p>
            <p className="text-muted mb-4">
              Acesse com o mesmo login e senha que você já usa aqui.
            </p>
            <Button color="primary" onClick={handleGoToNewApp} className="px-3">
              <ExternalLink size={16} className="mr-1" />
              Acessar a nova plataforma
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </footer>
  );
};

export default Footer;
